﻿import React from 'react';
import {Helmet} from "react-helmet";
import { useTranslation } from 'react-i18next';

import Client_Websites_Table from '@Elements/Client_Websites_Table';
import { H1 } from '@Elements/Fonts';

export default function ClientWebsitespage(): JSX.Element {
    const [t] = useTranslation();

    return (
        <>
            <Helmet>
                <title>{`${t('Navigation.CustomerWebsites')} - InTime`}</title>
            </Helmet>
            <H1>{t('Navigation.CustomerWebsites')}</H1>
            <Client_Websites_Table />
        </>
    );
}